/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)

// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
// import moduleChat from './chat/moduleChat.js'
import moduleBusinessCategory from './businessCategory/moduleBusinessCategory.js'
import moduleAccount from './account/moduleAccount.js'
import modulePermission from './permission/modulePermission'
// import moduleEmail from './email/moduleEmail.js'
import moduleAuth from './auth/moduleAuth.js'


let store = new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    // todo: moduleTodo,
    // calendar: moduleCalendar,
    // chat: moduleChat,
    // email: moduleEmail,
    businessCategory: moduleBusinessCategory,
    account: moduleAccount,
    permission: modulePermission,
    auth: moduleAuth,
  },
  strict: process.env.NODE_ENV !== 'production'
})
store.reset=()=>{
  // let newState = {};
  // Object.keys(store.state).forEach(key => {
  //   newState[key] = {}; // or = initialState[key]
  // });
  // store.replaceState(newState);
  store.state.account.items={};
  store.state.account.default=null;
  store.state.account.myBalance=null;
}
export default store;